/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttachmentStorageBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AttachmentStorageBase.fixupPrototype; }

    static newInstance(model: Partial<AttachmentStorageBase>): AttachmentStorageBase {
        let obj = Object.assign(new AttachmentStorageBase(), model);
        AttachmentStorageBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttachmentStorageBase>): AttachmentStorageBase {
        if (!model) return null;
        return AttachmentStorageBase.newInstance(<AttachmentStorageBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttachmentStorageBase) {
        if (!obj) return;

        models.AttachmentStorageBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttachmentStorageBase): boolean {
        switch (obj.__type)
        {
            case "AttachmentStorageAzureBlob":
                Object.setPrototypeOf(obj, models.AttachmentStorageAzureBlob.prototype);
                break;
            case "AttachmentStorageCorestack":
                Object.setPrototypeOf(obj, models.AttachmentStorageCorestack.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AttachmentStorageBase)[] {
        return [
            models.AttachmentStorageAzureBlob,
            models.AttachmentStorageCorestack,
        ];
    }

    fixupFields() {
        if (this.size === undefined) {
            this.size = 0;
        }
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.expires_at === "string") {
            this.expires_at = new Date(<string><any>this.expires_at);
        }
    }

    /**
     * Original file name
     */
    file_name: string;

    /**
     * Size of file in bytes
     */
    size: number;

    /**
     * Date and Time of the attachment creation
     */
    created_at: Date;

    /**
     * Date and Time when the attachment expires. If not set, the attachment does not expire.
     */
    expires_at: Date;

}
